// Gallery.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import { galleryData } from '../data/galleryData';
import '../styles/gallery.css';
import CTASection from '../components/CTASection';

const Gallery = () => {
  // State for cycling images - must be at the top before any returns
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Get cover images from all gallery sections (first image of each section)
  const heroImages = galleryData && Array.isArray(galleryData)
    ? galleryData.map(section => section.images[0])
    : [];

  // Auto-cycle through images every 5 seconds
  useEffect(() => {
    if (isPaused || heroImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000); // 2 seconds per image

    return () => clearInterval(interval);
  }, [isPaused, heroImages.length]);

  // Check if galleryData exists
  if (!galleryData || !Array.isArray(galleryData)) {
    console.error('galleryData is not properly imported or is not an array');
    return (
      <div className="gallery-page">
        <Navbar />
        <div style={{ padding: '4rem', textAlign: 'center' }}>
          <h2>Error loading gallery data</h2>
          <p>Please check that galleryData.js exists and exports an array.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-page">
      <Navbar />
      <Breadcrumb customLabel="Portfolio" />

      {/* Hero Section with Cycling Images */}
      <section
        className="gallery-hero"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {heroImages.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            className={`hero-image ${index === currentImageIndex ? 'active' : ''}`}
            loading={index === 0 ? 'eager' : 'lazy'}
            decoding="async"
          />
        ))}
        <div className="gallery-hero-content">
          <h1 className="gallery-hero-title">Our Gallery</h1>
          <p className="hero-subtitle">
            Transforming Idaho landscapes since 1990
          </p>
          <div className="gallery-hero-buttons">
            <a href="mailto:info@allseasons.info" className="btn-cta">
              Request A Consultation
            </a>
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="hero-nav-dots">
          {heroImages.map((_, index) => (
            <button
              key={index}
              className={`nav-dot ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <div className="gallery-grid-container">
        <div className="gallery-grid">
          {galleryData.map((section, idx) => {
            // Get the first image as the cover image
            const coverImage = section.images[0];
            
            return (
              <Link
                key={idx}
                to={`/gallery/${section.folder}`}
                className="gallery-tile"
              >
                <div className="tile-image-container">
                  <img 
                    src={coverImage.src} 
                    alt={coverImage.alt}
                    className="tile-image"
                  />
                  <div className="tile-overlay">
                    <h3 className="tile-title">{section.section}</h3>
                    <span className="tile-arrow">→</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

        {/* Final CTA */}
     <CTASection 
  title="Ready to Transform Your Space?"
  subtitle="Let's bring your vision to life"
  galleryLink="/Home"
  showEmergency={false}
/>
    </div>
  );
};

export default Gallery;